import marketPlaceabi from "./MarketPlace.json";
import nftabi from "./Nft.json";

export const nftAddress = "0x1ddd129Bf220b9772571727a4d70efAA28832F94";
export const nftABI = nftabi.abi;

export const marketPlaceAddress = "0x56c80135890B0FB942E2Dc7E13FFB7a49D1c59a5";
export const marketPlaceABI = marketPlaceabi.abi;